import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { default as Header } from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import useAPI from "../../Hooks/useAPI";
import SecHeader from "../../Components/SecHeader/SecHeader";
import "./ConfirmEmail.css";

const ConfirmEmailPage: React.FC = () => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { confirmEmail } = useAPI();

  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const runConfirmation = async () => {
      setError("");
      setSuccess("");

      const token = searchParams.get("token");
      if (!token) {
        setError("Invalid confirmation link");
        return;
      }

      try {
        await confirmEmail(token);
        setSuccess("Your email has been confirmed!");

        setTimeout(() => {
          navigate("/user-login");
        }, 3000);
      } catch {
        setError("Invalid confirmation link");
      }
    };

    runConfirmation();
  }, [navigate, confirmEmail, searchParams]);

  return (
    <>
      <div className="generalPage">
        <Header />
        <div className="pageContainer">
          <div className="confirm-password-title-container">
            <div className="sectionContainer">
              <SecHeader title="Confirming Email" iSize={3} />
            </div>
            <div className="confirm-password-container">
              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">{success}</div>}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ConfirmEmailPage;
